import { setLocal, getLocal } from '@/common/js/api'
export default {
  methods: {
    changePageIndex (index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize (size) {
      this.setLocalPage(size) // 设置常用页码
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    setLocalPage (size) {
      setLocal('PAGESIZE', size)
    },
    searchFilterData (params) {
      this.pageIndex = 1
      this.getData(params)
    },
    filterData (params) {
      this.pageIndex = 1
      this.getData(params)
    }
  },
  data () {
    return {
      loading: null,
      pageIndex: 1,
      pageSize: parseInt(getLocal('PAGESIZE')) || 20,
      total: 0,
      tableList: [],
      tableCol: []
    }
  }
}
